import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.293 15.1c-.32 0-.633-.08-.926-.24a1.8 1.8 0 0 1-.94-1.587V9.74c0-.333-.22-.833-.427-1.087l-2.493-2.64c-.42-.42-.74-1.14-.74-1.68V2.8c0-1.067.806-1.9 1.833-1.9h8.8c1.013 0 1.833.82 1.833 1.833V4.2c0 .7-.42 1.493-.813 1.887L10.533 8.64c-.28.233-.5.747-.5 1.16v2.867c0 .593-.373 1.28-.84 1.56l-.92.593c-.3.187-.64.28-.98.28M3.6 1.9c-.467 0-.833.393-.833.9v1.533c0 .247.2.727.453.98l2.54 2.674c.34.42.673 1.12.673 1.746v3.534c0 .433.3.646.427.713.28.153.62.153.88-.007l.927-.593c.186-.113.373-.473.373-.713V9.8c0-.713.347-1.5.847-1.92l2.853-2.527c.227-.226.5-.766.5-1.16v-1.46a.834.834 0 0 0-.833-.833z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 7.167a.55.55 0 0 1-.267-.074.506.506 0 0 1-.16-.693L6.86 1.133a.498.498 0 1 1 .847.527L4.42 6.927a.49.49 0 0 1-.42.24"
    }, null, -1)
  ]))]))
}
export default { render: render }